var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 81,
    viewBox: "0 0 501 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.570312 80.9302H50.6594L57.8728 63.7431H0.570312V80.9302Z",
    fill: "#0098F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 60.3082L62.3293 51.7821L69.8862 33.356L0.5 43.0352V60.3082Z",
    fill: "#0098F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 39.6493L75.5785 20.5362L84.0309 0L0.5 21.8243V39.6493Z",
    fill: "#0099FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.613 48.6908H137.089L142.523 35.822H120.613V26.9034H146.289L152.117 13.1512L152.166 13.0286H104.469V71.9014H152.239V58.0266H120.613V48.6908Z",
    fill: "#010100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.265 18.5367C321.861 14.8686 315.899 13.0285 308.391 13.0285H283.156V71.9135H299.472V55.0945H307.557C315.126 55.0945 321.235 53.2421 325.897 49.5495C330.546 45.8446 332.877 40.6308 332.877 33.9081C332.865 27.3204 330.657 22.2047 326.265 18.5367ZM314.059 40.1892C312.403 41.5877 310.121 42.2993 307.201 42.2993H299.46V26.7315H307.115C310.084 26.7315 312.403 27.394 314.059 28.7066C315.715 30.0193 316.537 31.9453 316.537 34.4725C316.549 36.8892 315.715 38.7907 314.059 40.1892Z",
    fill: "#010100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.851 13.0285H338.535V71.9013H374.639L380.687 57.6094H354.851V13.0285Z",
    fill: "#010100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M408.481 12.5992L387.418 62.4306L383.406 71.9013H388.89H400.569L404.777 61.3879H427.484L431.778 71.9013H449.284L424.209 12.5992H408.481ZM409.561 48.6908L416.21 31.9453L422.773 48.6908H409.561Z",
    fill: "#010100"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M482.248 13.0285L470.041 34.4725L457.933 13.0285H439.348L461.724 49.8684V71.9013H478.114V49.6108L500.502 13.0285H482.248Z",
    fill: "#010100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M200.432 13.0285L187.048 50.2855L173.676 13.0285H155.422L179.319 72.3306H194.458L218.343 13.0285H200.432Z",
    fill: "#010100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M245.936 11.9857C229.043 11.9857 215.34 25.6887 215.34 42.5814C215.34 59.474 229.043 73.1771 245.936 73.1771C262.828 73.1771 276.531 59.474 276.531 42.5814C276.531 25.6887 262.828 11.9857 245.936 11.9857ZM245.936 58.6398C237.066 58.6398 229.889 51.4509 229.889 42.5936C229.889 33.7241 237.078 26.5474 245.936 26.5474C254.805 26.5474 261.982 33.7363 261.982 42.5936C261.982 51.4509 254.793 58.6398 245.936 58.6398Z",
    fill: "#010100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8ae7442bbcd886f29b1d4add16e2e037.svg";
export { ForwardRef as ReactComponent };